export class WebhookV1StandardPayloadNotificationTargetChangeArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "notificationTargetChange",
            "baseName": "notificationTargetChange",
            "type": "WebhookV1NotificationTargetChangeArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadNotificationTargetChangeArguments.attributeTypeMap;
    }
    constructor() {
    }
}
